// Central API configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3101';

// Helper function to build API URLs
export const apiUrl = (path: string): string => {
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

export default API_BASE_URL;
